var EXEC_QUERY_METHOD = 'dlad_sap_connector.dlad_sap_connector.api.execute_query';
var IS_TESTER = 'dlad_sap_connector.dlad_sap_connector.api.is_tester';
var EXEC_SAP_SERVICE = 'dlad_sap_connector.dlad_sap_connector.api.gw';
var EXEC_REPORT_QUERY = "dlad_sap_connector.dlad_sap_connector.query_report.run";
var SUBMIT_DOC = "frappe.desk.form.save.savedocs";
var USER_STATE = 'frappe.auth.get_logged_user';
var GET_PAGE_MODEL = 'dlad_core.ui.page.get';
export { EXEC_QUERY_METHOD, EXEC_SAP_SERVICE, EXEC_REPORT_QUERY, SUBMIT_DOC, USER_STATE, IS_TESTER, GET_PAGE_MODEL };
